import React, { Component } from "react";
import { Icon } from "../../elements";
import "./style.scss";
import { connect } from "react-redux";
import { selectModelShow } from "../../selectors/application";
const StickyButton = props => {
  const { fields } = props;
  const { backToTopText } = fields;
  const onBackToTop = e => {
    document.body.style.overflowY = "auto";
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
  };
  return (
    <div className="c-sticky-button"style={{ opacity: props.showModel? 0 : 1 }}>
      <button className="back-to-top" onClick={onBackToTop}>
        <Icon name="ArrowTop" />
        <span>{backToTopText.value}</span>
      </button>
    </div>
  );
};
const mapStateToProps = state => ({
  showModel: selectModelShow(state),
});
export default connect(mapStateToProps, null)(StickyButton);

